import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/subscribe")({
  head: () => buildRouteHead("/es/subscribe", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/suscribete", replace: true });
  },
});
